import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Grid, Popup, Icon, Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

const {updateUserRequest} = Actions;

const DeleteIcon = ({dealerId, id, isUserFromTDE}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDeleteClick = () => {
    const status = 'D';
    dispatch(updateUserRequest(id, {status, dealerId, isUserFromTDE}));
  };

  return (
    <Popup
      wide
      inverted
      on='click'
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      trigger={<Icon link color='red' size='big' name='delete' />}
    >
      <Grid>
        <Grid.Row>
          <Grid.Column textAlign='center'>
            <div>¿Desea eliminar la solicitud de usuario?</div>
            <Button secondary size='mini' onClick={handleClose}>
              CANCELAR
            </Button>
            <Button primary size='mini' onClick={handleDeleteClick}>
              ELIMINAR
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Popup>
  );
};

export default DeleteIcon;
